<template>
  <main class="page-brands page-main__wrapper layout">
    <!-- 条件查询部分 -->
    <section class="filter-box">
      <el-form :inline="true" class="filter-form">
        <el-form-item label="定制系统类型:">
          <el-select
            style="width: 110px"
            v-model="filter.serviceType"
            filterable
            placeholder="定制系统类型"
          >
            <el-option
              style="width: 110px"
              v-for="item in filter.serviceTypes"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="定制系统:">
          <div class="autocomplete-box">
            <el-autocomplete
              v-model="filter.sysName"
              :fetch-suggestions="$_searchCCompanies"
              :trigger-on-focus="false"
              value-key="sysName"
              @select="$_selectCCompany"
              class="input-box"
            ></el-autocomplete>
            <div
              v-show="!searchCCompaniesData.length && filter.sysName"
              @click="$_clearSearchCCompanyData('supplier')"
              class="autocomplete-empty el-select-dropdown"
            >
              查无该定制系统，请重新输入
            </div>
          </div>
        </el-form-item>

        <el-form-item label="运营商名称:">
          <div class="autocomplete-box">
            <el-autocomplete
              style="width: 110px"
              v-model="filter.platformName"
              :fetch-suggestions="$_handleSearchPlatform"
              :trigger-on-focus="false"
              value-key="platformName"
              @select="$_handleSelectPlatform"
            ></el-autocomplete>
            <div
              v-show="!searchPlatformData.length && filter.platformName"
              @click="$_clearSearchPlatformData"
              class="autocomplete-empty el-select-dropdown"
            >
              查无该运营商，请重新输入
            </div>
          </div>
        </el-form-item>

        <el-form-item label="品牌名称:">
          <div class="autocomplete-box">
            <el-autocomplete
              style="width: 110px"
              v-model="filter.brandName"
              :fetch-suggestions="$_handleSearchBrand"
              :trigger-on-focus="false"
              value-key="brandName"
              @select="$_handleSelectBrand"
            ></el-autocomplete>
            <div
              v-show="!searchBrandData.length && filter.brandName"
              @click="$_clearSearchBrandData"
              class="autocomplete-empty el-select-dropdown"
            >
              查无该品牌，请重新输入
            </div>
          </div>
        </el-form-item>

        <el-form-item label="业务类型:">
          <el-select
            v-model="filter.orderType"
            filterable
            style="width: 110px"
            placeholder="请选择"
          >
            <el-option label="全部" :value="0"></el-option>
            <el-option
              v-for="item in filter.orderTypeEnums"
              :key="item.type"
              :label="item.name"
              :value="item.type"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="门店名称:">
          <div class="autocomplete-box" style="width: 110px">
            <el-autocomplete
              v-model="filter.storeName"
              :fetch-suggestions="$_handleSearchStores"
              :trigger-on-focus="false"
              value-key="storeName"
              @select="$_handleSelectStore"
            ></el-autocomplete>
            <div
              v-show="!searchStoresData.length && filter.storeName"
              @click="$_clearsearchStoresData"
              class="autocomplete-empty el-select-dropdown"
            >
              查无该门店，请重新输入
            </div>
          </div>
        </el-form-item>

        <el-form-item label="门店ID:">
          <el-input v-model="filter.storeId" style="width: 110px"></el-input>
        </el-form-item>

        <el-form-item label="系统订单号:">
          <el-input v-model="filter.orderId"></el-input>
        </el-form-item>

        <el-form-item label="外卖平台订单号:">
          <el-input v-model="filter.extOrderId"></el-input>
        </el-form-item>

        <el-form-item label="外卖平台流水号:">
          <el-input v-model="filter.thirdSn"></el-input>
        </el-form-item>

        <el-form-item label="第三方订单号:">
          <el-input v-model="filter.subOrderId"></el-input>
        </el-form-item>

        <el-form-item label="订单状态:">
          <el-select
            v-model="filter.orderStatus"
            filterable
            style="width: 110px"
            placeholder="请选择"
          >
            <el-option label="全部" :value="0"></el-option>
            <el-option
              v-for="item in filter.statusEnums"
              :key="item.status"
              :label="item.name"
              :value="item.status"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="联系电话:">
          <el-input v-model="filter.phone"></el-input>
        </el-form-item>

        <el-form-item label="下单时间:">
          <el-date-picker
            v-model="filter.orderTime"
            type="datetimerange"
            range-separator=" - "
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="pickerOptions"
            @blur="$_clearDate"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button @click="$_search" class="search__btn">查询</el-button>
          <el-button @click="$_reset" class="reset__btn">重置</el-button>
        </el-form-item>
      </el-form>
    </section>

    <main class="table-box">
      <!-- 数据列表 -->
      <el-table
        class="table-list__box"
        ref="tableList"
        :data="dataList"
        :height="tableHeight"
        :rowClassName="$_getRowClass"
        v-loading="isLoading"
        border
        stripe
        tooltip-effect="dark"
      >
        <el-table-column label="操作" width="140" :resizable="false">
          <template slot-scope="scope">
            <el-button class="edit__btn" @click="$_modify(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>

        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          show-overflow-tooltip
          filter-placement="bottom"
          v-if="!column.component"
        ></el-table-column>
        <el-table-column
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          v-else
        >
          <template slot-scope="scope">
            <component :is="column.component" :row="scope.row"></component>
          </template>
        </el-table-column>

        <div v-show="!isLoading" class="table-list__empty" slot="empty"></div>
      </el-table>
    </main>
    <!-- 分页 -->
    <div class="pagination__wrapper">
      <cd-pagination
        ref="pager"
        :total="pagination.total"
        :currPage="pagination.pageNow"
        :pageSize="pagination.pageSize"
        @changepage="$_changeCurrent"
        @changesize="$_changeSize"
        :explainShow="true"
        @refresh="$_getBrandList"
      ></cd-pagination>
    </div>

    <modal-modify
      v-if="modal.show && modal.template === 'modify'"
      :title="modal.title"
      @callback="$_callback"
      @close="$_close"
      :postData="modal.postData"
    ></modal-modify>
  </main>
</template>

<script>
import * as Utils from "@/plugins/utils";
import resize from "@/mixins/resize";
import autocompleteCustomCompanys from "@/mixins/autocompleteCustomCompanys";
import modalModify from "./modal-order-view";

const columns = [
  { key: "vendorName", label: "定制系统", width: 120 },
  { key: "sysType", label: "定制系统类型", width: 120 },
  { key: "platformName", label: "运营商", width: 120 },
  { key: "brandName", label: "品牌", width: 120 },
  { key: "orderTypeDesc", label: "业务类型", width: 120 },
  { key: "storeName", label: "门店名称", width: 120 },
  { key: "storeId", label: "门店ID", width: 120 },
  { key: "orderId", label: "系统订单号", width: 200 },
  { key: "extOrderId", label: "外卖平台订单号", width: 160 },
  { key: "thirdSn", label: "外卖平台流水号", width: 160 },
  { key: "subOrderId", label: "第三方订单号", width: 160 },
  { key: "orderStatusDesc", label: "订单状态", width: 120 },
  { key: "phone", label: "联系电话", width: 120 },
  { key: "orderTime", label: "下单时间", width: 160 },
  { key: "memo", label: "备注" },
];
let minPickerDate = "";
let maxPickerDate = "";
export default {
  name: "custom-orderview",
  mixins: [resize, autocompleteCustomCompanys],
  data() {
    return {
      isLoading: false,
      filter: {
        syses: [],
        serviceType: "", // 定制系统类型
        serviceTypes: [],
        orderTypeEnums: [],
        statusEnums: [], // 订单状态枚举
        startOrderTime: "",
        endOrderTime: "",
        orderTime: [],
        sysType: "", // 定制系统 mixin与接口定义冲突
        vendor: "", // 定制系统
        platformKey: "",
        brandName: "", // 品牌名称
        brandId: 0, // 品牌brandId
        orderType: 0,
        storeId: "",
        storeName: "",
        orderId: "",
        extOrderId: "",
        thirdSn: "",
        subOrderId: "",
        orderStatus: 0,
        phone: "",
      },
      searchBrandData: [],
      searchStoresData: [],
      searchPlatformData: [],
      tableHeight: null,
      dataList: [],
      columns,
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0,
      },
      modal: {
        show: false,
        template: "",
        postData: {},
      },
      pickerOptions: {
        disabledDate(date) {
          let today = Utils.formatDate(new Date(), "yyyy-MM-dd");
          let smaller = Date.parse(today) + 1000 * 60 * 60 * 16 - 1;
          if (maxPickerDate && maxPickerDate < smaller) {
            smaller = maxPickerDate - 1000 * 60 * 60 * 8 - 1; // 每天的时间以8点为始点
          }
          return date.getTime() > smaller || date.getTime() < minPickerDate;
        },
        onPick({ minDate, maxDate }) {
          if (maxDate === null) {
            let min = Utils.formatDate(minDate, "yyyy-MM-dd");
            minPickerDate = Date.parse(min) - 1000 * 60 * 60 * 8; // 每天的时间以8点为始点
            maxPickerDate = Date.parse(min) + 1000 * 60 * 60 * 24 * 7;
          } else {
            minPickerDate = "";
            maxPickerDate = "";
          }
        },
      },
    };
  },
  watch: {
    platformName(val) {
      !val && (this.filter.platformKey = "");
    },
    brandName(val) {
      if (!val) this.filter.brandId = 0;
    },
  },
  computed: {
    platformName() {
      return this.filter.platformName;
    },
    brandName() {
      return this.filter.brandName;
    },
  },
  methods: {
    // 还原时间跨度数值
    $_clearDate() {
      minPickerDate = "";
      maxPickerDate = "";
    },
    // 下拉联想品牌
    $_handleSearchBrand(brandName, cb) {
      let postData = {
        brandName: brandName,
        pageNow: 1,
        pageSize: 9999,
      };
      this.$service.post("getBrands", postData).then((result) => {
        if (result.$.checkResult(result, true)) {
          this.searchBrandData = result.data.rows.concat([]);
          cb(result.data.rows);
        }
      });
    },
    // 选择品牌
    $_handleSelectBrand(item) {
      this.filter.brandName = item.brandName;
      this.filter.brandId = item.brandId;
    },
    $_clearSearchBrandData() {
      this.filter.brandName = "";
      this.filter.brandId = 0;
    },
    // 下拉联想门店
    $_handleSearchStores(storeName, cb) {
      let postData = {
        storeName,
        pageNow: 1,
        pageSize: 9999,
      };
      if (this.filter.brandId !== 0) {
        Object.assign(postData, { brandId: this.filter.brandId });
      }
      this.$service.post("getStores", postData).then((result) => {
        if (result.$.checkResult(result, true)) {
          this.searchStoresData = result.data.rows.concat([]);
          cb(result.data.rows);
        }
      });
    },
    // 选择门店
    $_handleSelectStore(item) {
      this.filter.storeName = item.storeName;
      this.filter.storeId = item.storeId;
    },
    $_clearsearchStoresData() {
      this.filter.storeName = "";
      this.filter.storeId = "";
    },
    // 下拉联想运营商
    $_handleSearchPlatform(platformName, cb) {
      let postData = {
        platformName: platformName,
        pageNow: 1,
        pageSize: 9999,
      };
      this.$service.post("getPlatformList", postData).then((result) => {
        if (result.$.checkResult(result, true)) {
          this.searchPlatformData = result.data.rows.concat([]);
          cb(result.data.rows);
        }
      });
    },
    // 选择运营商
    $_handleSelectPlatform(item) {
      this.filter.platformName = item.platformName;
      this.filter.platformKey = item.platformKey;
    },
    $_clearSearchPlatformData() {
      this.filter.platformName = "";
      this.filter.platformKey = "";
    },
    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      this.$_getBrandList();
    },
    // 重置
    $_reset() {
      minPickerDate = "";
      let today = Utils.formatDate(new Date(), "yyyy-MM-dd");
      this.filter.startOrderTime = `${today} 00:00:00`;
      this.filter.endOrderTime = `${today} 23:59:59`;
      this.filter.orderTime = [`${today} 00:00:00`, `${today} 23:59:59`];
      for (const [key, value] of Object.entries(this.filter)) {
        if (!~["startOrderTime", "endOrderTime", "orderTime"].indexOf(key)) {
          if (typeof value === "string") {
            this.filter[key] = "";
          } else if (typeof value === "number") {
            this.filter[key] = 0;
          }
        }
      }
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getBrandList();
    },
    // 查询订阅关系列表
    $_getBrandList() {
      this.isLoading = true;
      this.$refs.tableList.clearSort();

      const postData = {
        sysType: this.filter.serviceType,
        vendor: this.filter.sysType,
        platformKey: this.filter.platformKey,
        // brandId: this.filter.brandId || this.brandId,
        orderType: this.filter.orderType || this.orderType,
        storeId: this.filter.storeId || this.storeId,
        orderId: this.filter.orderId,
        extOrderId: this.filter.extOrderId,
        thirdSn: this.filter.thirdSn,
        subOrderId: this.filter.subOrderId,
        orderStatus: this.filter.orderStatus || this.orderStatus,
        phone: this.filter.phone,
        startOrderTime: this.filter.orderTime[0],
        endOrderTime: this.filter.orderTime[1],
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize,
      };
      if (this.filter.brandId !== 0) {
        Object.assign(postData, { brandId: this.filter.brandId });
      }
      this.$service.post("customOrder", postData).then((result) => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    },
    $_getRowClass({ row, rowIndex }) {
      if (row.status === 2) {
        return "is-blocked";
      }
    },
    // 新增/编辑成功回调
    $_callback() {
      this.$_close();
      this.$_getBrandList();
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.data = {};
      this.modal.title = "";
    },
    // 新增/编辑
    $_modify(row) {
      this.modal.show = true;
      this.modal.template = "modify";
      this.modal.show = true;
      this.modal.postData = row;
    },

    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getBrandList();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getBrandList();
    },
  },
  created() {
    let today = Utils.formatDate(new Date(), "yyyy-MM-dd");
    this.filter.startOrderTime = `${today} 00:00:00`;
    this.filter.endOrderTime = `${today} 23:59:59`;
    this.filter.orderTime = [`${today} 00:00:00`, `${today} 23:59:59`];
  },
  async mounted() {
    // 获取定制系统类型
    let result = await this.$service.post("getCustomServiceTypes");
    if (result.$.checkResult(result, true)) {
      this.filter.serviceTypes = [...result.data];
    } else {
      return false;
    }
    // 获取业务类型类型
    await this.$service.post("orderTypeEnums").then((result) => {
      if (result.$.checkResult(result, true)) {
        this.filter.orderTypeEnums = result.data.concat([]);
      }
    });
    // 获取定制系统
    await this.$service
      .post("getCustomCompanys", {
        pageNow: 1,
        pageSize: 9999,
        sysType: "",
      })
      .then((result) => {
        if (result.$.checkResult(result, true)) {
          if (result.data.rows.length > 0) {
            this.filter.syses = result.data.rows.concat([]);
          }
        }
      });
    // 获取订单状态枚举
    await this.$service.post("getOrderStatusEnums").then((result) => {
      if (result.$.checkResult(result, true)) {
        this.filter.statusEnums = result.data.concat([]);
      }
    });
    let height = this.$refs.tableList.$el.parentElement.clientHeight;
    this.tableHeight = `${height}px`;
    this.$_getBrandList();
  },
  components: {
    modalModify,
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
}
.page-main__wrapper {
  overflow: hidden;
  position: relative;
  height: 100%;
  border: 1px solid #eee;
}

.filter-box {
  color: #68768a;
  background-color: #f5f6f7;
  padding: 6px 20px 10px;
  .filter-form {
    .el-form-item {
      margin-top: 14px;
    }
  }
}

.table-box {
  height: 100vh;
  border-top: 1px solid #eee;
  overflow-x: auto;
  position: relative;
}
</style>
<style lang="scss">
.page-app-logs {
  .filter-box {
    .el-input {
      width: 110px;
      &.el-date-editor {
        width: 140px;
      }
    }
  }
}
</style>
